run.$inject = [ '$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'integralEvaluation' ]

export default function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, integralEvaluation) {
	// teacher self assessment
	$templateCache.put('teaching.html', require('./teacherSelfAssessment/teacherSelfAssessmentTemplates/teaching.html'))
	$templateCache.put('teacherWorkPlan.html', require('./teacherSelfAssessment/teacherSelfAssessmentTemplates/teacherWorkPlan.html'))
	$templateCache.put('commitment.html', require('./teacherSelfAssessment/teacherSelfAssessmentTemplates/commitment.html'))
	$templateCache.put('openQuestions.html', require('./teacherSelfAssessment/teacherSelfAssessmentTemplates/openQuestions.html'))
	$templateCache.put('finalConcept.html', require('./teacherSelfAssessment/teacherSelfAssessmentTemplates/finalConcept.html'))
	// teacher assessment
	$templateCache.put('teacherAssessment_home.html', require('./teacherAssessment/teacherAssessmentTemplates/teacherAssessment_home.html'))
	$templateCache.put('teacherAssessment_teacherWorkPlan.html', require('./teacherAssessment/teacherAssessmentTemplates/teacherAssessment_teacherWorkPlan.html'))
	$templateCache.put('teacherAssessment_commitment.html', require('./teacherAssessment/teacherAssessmentTemplates/teacherAssessment_commitment.html'))
	$templateCache.put('teacherAssessment_openQuestions.html', require('./teacherAssessment/teacherAssessmentTemplates/teacherAssessment_openQuestions.html'))
	$templateCache.put('teacherAssessment_finalConcept.html', require('./teacherAssessment/teacherAssessmentTemplates/teacherAssessment_finalConcept.html'))
	MenuConstant[0]['menu'].push(integralEvaluation)
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/integralEvaluation/integralEvaluation.run.js